module.exports = __webpack_public_path__ + "img/IMG_0289.3165fcda.png";